import { render, staticRenderFns } from "./EditDrives.vue?vue&type=template&id=106b2484&"
import script from "./EditDrives.vue?vue&type=script&lang=js&"
export * from "./EditDrives.vue?vue&type=script&lang=js&"
import style0 from "./EditDrives.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports